export default "__VITE_ASSET__f8fde428__"